import React from "react";

import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

type Props = { className?: string };

export const Statistics = (props: SvgIconProps & Props) => {
    return (
        <SvgIcon {...props}>
            <path
                d="M19 8L12.9545 14.0455L9.77273 10.8636L5 15.6364"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M15.1818 8H18.9999V11.8182" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
};
